import { forwardRef } from 'react';
import { cn } from '@/lib/cn';

export const SelectField = forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
    ({ className, children, ...props }, ref) => (
        <select
            ref={ref}
            className={cn(
                'w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-text',
                'focus:border-accent focus:outline-none',
                'disabled:opacity-50 disabled:cursor-not-allowed',
                'transition-colors duration-[var(--duration-base)]',
                className,
            )}
            {...props}
        >
            {children}
        </select>
    ),
);
SelectField.displayName = 'SelectField';
